export const FormatDistance = (distance) => {
    if(distance >= 1000) {
        distance = (distance / 1000).toFixed(1) + 'km'
    } else {
        distance = distance + 'm'
    }
    return `约${distance}`
}